export enum MediaLibraryFile {
	VIDEO,
	PDF,
	IMAGE
}
